<template>
    <div id="itemTypePrice">
     
        <h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps">{{collaps == true ? '-' : '+'}} {{$t('i_TypeDePrix')}}</h6>
            <span v-show="collaps">
                <s-duoSelector style="margin-left: -15px" :text1="$t('i_Positif')" :text2="$t('i_Negatif')" :value="chkNegatif" :returnValue.sync="chkNegatif"></s-duoSelector>
                <s-duoSelector style="margin-left: -15px" :text1="$t('i_Regulier')" :text2="$t('i_Essence')" :value="chkGazPrice" :returnValue.sync="chkGazPrice"></s-duoSelector>
                <s-duoSelector style="margin-left: -15px" :text1="$t('i_Fixe')" :text2="$t('i_Ouvert')" :value="chkOpenClose" :returnValue.sync="chkOpenClose"></s-duoSelector>
            </span>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemTypePrice',
    components: {

    },
    props: ['isNegative', 'isGazPrice', 'isOpen'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        chkNegatif: {
            get: function() {return this.isNegative},
            set: function(modifiedValue){this.$emit('update:isNegative', modifiedValue)}
        },
        chkGazPrice: {
            get: function() {return this.isGazPrice},
            set: function(modifiedValue){this.$emit('update:isGazPrice', modifiedValue)}
        },
        chkOpenClose: {
            get: function() {return this.isOpen},
            set: function(modifiedValue){this.$emit('update:isOpen', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>

</style>